import { DataStatus } from '@/shared/lib';
import type { ProductDTO } from '../api/types';
import type { ApplicationPlatform, Product } from '../model/types';

export const mapProduct = (dto: ProductDTO): Product => {
  return {
    id: dto.id,
    name: dto.name,
    applicationPlatforms: dto.applicationPlatforms as ApplicationPlatform[],
    applications: [],
    applicationsDataStatus: DataStatus.idle,
    webhooks: [],
    webhooksDataStatus: DataStatus.idle,
    createdAt: dto.createdAt,
    updatedAt: dto.updatedAt,
  };
};
